import * as React from 'react';
import { useAnimatedPlaceholder_unstable } from './useAnimatedPlaceholder';
import { renderAnimatedPlaceholder_unstable } from './renderAnimatedPlaceholder';
import { useAnimatedPlaceholderStyles_unstable } from './useAnimatedPlaceholderStyles.styles';
import type { AnimatedPlaceholderProps } from './AnimatedPlaceholder.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

export const AnimatedPlaceholder: ForwardRefComponent<AnimatedPlaceholderProps> = React.forwardRef((props, ref) => {
  const state = useAnimatedPlaceholder_unstable(props, ref);

  useAnimatedPlaceholderStyles_unstable(state);
  return renderAnimatedPlaceholder_unstable(state);
});

AnimatedPlaceholder.displayName = 'AnimatedPlaceholder';
